import React, { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { Field } from 'formik';
import {
  TextField,
  Paper,
  Grid,
} from '@material-ui/core';

import { InputLabel } from '../Containers';

export default ({
  input,
  value,
  extraInputs,
  formName,
  controlName,
  disabled,
  stateIndex,
}) => {
  const [extraInputsList, setExtraInputsList] = useState(extraInputs);
  useEffect(() => {}, [extraInputsList]);

  const {
    name, label, hint, defaultValue, range, required, length,
  } = input;

  const intl = useIntl();
  const hintText = (hint && hint['0']) || '';
  const labelText = (label && label['0']) || '';

  let fieldName = `${formName}`;
  if (controlName) {
    fieldName = fieldName.concat(`.${controlName}`);
  }
  fieldName = fieldName.concat(`.${name}`);

  return (
    <Field
      name={fieldName}
      validate={(vv) => {
        if (required && !disabled) {
          if (Array.isArray(vv)) {
            let message = '';
            vv.map((vvv) => {
              if (vvv.length === 0) {
                message = intl.formatMessage({ id: 'REQUIRED_THIS_FIELD' });
              }
            });
            return message;
          }
          if (vv.length === 0) {
            return intl.formatMessage({ id: 'REQUIRED_THIS_FIELD' });
          }
        }
        if (length && !disabled) {
          if (Array.isArray(vv)) {
            let message = '';
            vv.map((vvv) => {
              if (!(vvv.length >= length.min && vvv.length <= length.max)) {
                message = 'LENGTH';
              }
            });
            return message;
          }
          if (!(vv.length >= length.min && vv.length <= length.max)) {
            return 'LENGTH';
          }
        }
      }}
    >
      {(props) => {
        const {
          field, form, meta, value,
        } = props;
        return (
          <Grid
            container
            spacing={2}
            direction="row"
            justify="center"
            alignItems="center"
          >
            <Grid item xs={3}>
              <InputLabel>
                {hintText}{required ? ' (*)' : ''}
                {
                  length
                    ? (
                      <>
                        <br />
                        ({intl.formatMessage({ id: 'LENGTH' })}:
                        <br />
                        Min: {length.min}, Max: {length.max})
                      </>
                    )
                    : ''
                }
              </InputLabel>
            </Grid>
            <Grid item xs={9}>
              <Paper elevation={3}>
                <TextField
                  multiline
                  rows={4}
                  rowsMax={4}
                  disabled={disabled}
                  variant="outlined"
                  fullWidth
                  style={{ backgroundColor: '#fff' }}
                  error={meta.error}
                  helperText={meta.error}
                  placeholder={hintText}
                  // defaultValue={defaultValue}
                  onBlur={field.onBlur(name)}
                  onChange={(e) => {
                    form.setFieldValue(
                      extraInputsList && extraInputsList.length > 0
                        ? `${fieldName}.${stateIndex}`
                        : fieldName,
                      e.target.value,
                    );
                  }}
                  value={
                    extraInputsList && extraInputsList.length > 0
                      ? field.value && field.value[stateIndex]
                      : field.value
                  }
                />
              </Paper>
            </Grid>
          </Grid>
        );
      }}
    </Field>
  );
};
